export default __webpack_public_path__ + "static/media/white-logo.a3b01de0.svg";